import ENDPOINTS from 'api/endpoints';
import { doGet } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';
import type { AuditLogEntry } from './types';

export const getBranchAudit = (
  accountId: string,
  projectId: string,
  branchId: string,
  limit?: number,
  cursor?: string,
) => {
  return doGet<AuditLogEntry[]>(
    generateNextPath(
      ENDPOINTS.BRANCH_AUDIT,
      {
        accountId,
        projectId,
        branchId,
      },
      {
        limit: limit?.toString(),
        cursor,
      },
    ),
    LOGGER_TYPE.PROJECT,
    {
      prefix: 'sourcerer',
    },
  );
};

export const getProjectAudit = (
  accountId: string,
  projectId: string,
  limit?: number,
  cursor?: string,
) => {
  return doGet<AuditLogEntry[]>(
    generateNextPath(
      ENDPOINTS.PROJECT_AUDIT,
      {
        accountId,
        projectId,
      },
      {
        limit: limit?.toString(),
        cursor,
      },
    ),
    LOGGER_TYPE.PROJECT,
    {
      prefix: 'sourcerer',
    },
  );
};
